import React from 'react';
import { Route } from 'react-router-dom';

import ErrorBoundaryRoutes from 'app/shared/error/error-boundary-routes';

import Housing from './housing';
import HousingDetail from './housing-detail';
import HousingUpdate from './housing-update';
import HousingDeleteDialog from './housing-delete-dialog';

const HousingRoutes = () => (
  <ErrorBoundaryRoutes>
    <Route index element={<Housing />} />
    <Route path="new" element={<HousingUpdate />} />
    <Route path=":id">
      <Route index element={<HousingDetail />} />
      <Route path="edit" element={<HousingUpdate />} />
      <Route path="delete" element={<HousingDeleteDialog />} />
    </Route>
  </ErrorBoundaryRoutes>
);

export default HousingRoutes;
